import { Injectable } from '@angular/core';
import { MensajeModel } from '../Modelo/Mensajes.model';
import { Observable } from 'rxjs';
import { UtilidadesService } from '../utilidades/utilidades.servicios.index';
import { RespuestaModel } from '../utilidades/utilidades.modelos.index';

@Injectable({
	providedIn: 'root'
})
export class MensajesService {

	constructor(
		private Utilidades: UtilidadesService
	) { }

	public Nuevo(mensaje: MensajeModel, resource: string = 'Mensajes/Nuevo'): Observable<RespuestaModel> {
		return this.Utilidades.Post(resource, mensaje);
	}
}